import React from "react";
import avatar from "../../../images/avatar/1.png";
import { Dropdown } from "react-bootstrap";
import Logout from "./Logout";

const Header = ({ onNote }) => {
  var fullPath = window.location.hash.replace("#/", "");
  
  var filterName = "Estudiantes";
  if (fullPath === "" || fullPath.startsWith("students")) {
    filterName = "Estudiantes";
  } else if (fullPath.startsWith("concepts")) {
    filterName = "Conceptos";
  } else if (fullPath.startsWith("request")) {
    filterName = "Costos Periódicos";
  } else if (fullPath.startsWith("monthly")) {
    filterName = "Costos Mensuales";
  } else if (fullPath.startsWith("annualy")) {
    filterName = "Costos Anuales";
  } else if (fullPath.startsWith("config")) {
    filterName = "Configuraciones";
  } else if (fullPath.startsWith("users")) {
    filterName = "Administradores";
  } else if (fullPath.startsWith("degreechange")) {
    filterName = "Cambio de Grados";
  } else if (fullPath.startsWith("report")) {
    filterName = "Reportes";
  } else if (fullPath.startsWith("settlement")) {
    filterName = "Liquidación";
  } else if (fullPath.startsWith("nonpay")) {
    filterName = "Estudiantes en Mora";
  }
  
  

  return (
    <div className="header">
      <div className="header-content">
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse justify-content-between">
            <div className="header-left">
              <div
                className="dashboard_bar"
                style={{ textTransform: "capitalize" }}
              >
                {filterName}
              </div>
            </div>

            <ul className="navbar-nav header-right">
              <Dropdown as="li" className="nav-item dropdown header-profile">
                <Dropdown.Toggle variant="" as="a" className="nav-link i-false">
                  <img src={avatar} width={20} alt="profile" />
                </Dropdown.Toggle>

                <Dropdown.Menu align="right" className="mt-2 ">
                  <Logout />
                </Dropdown.Menu>
              </Dropdown>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
